<template>
  <div>
<!--    <b-tabs pills class="p-md-3 px-sm-2">-->
<!--      <b-tab :title="$t('monitoramento.resumo.tabs.latencia.tabs.ultimo')" lazy>-->

<!--      </b-tab>-->
<!--      <b-tab :title="$t('monitoramento.resumo.tabs.latencia.tabs.historico')" lazy>-->

<!--      </b-tab>-->
<!--    </b-tabs>-->
    <b-overlay :show="loadingIP">
      <div class="row m-0">
        <div class="col-lg-4 col-md-12 p-2">
          <LittleCard
              variant="warning"
              :text="$t('monitoramento.resumo.tabs.latencia.little_cards.ip_interno')"
              :value="latestIP.in"
              icon="network-wired"/>
        </div>
        <div class="col-lg-4 col-md-12 p-2">
          <LittleCard
              variant="warning"
              :text="$t('monitoramento.resumo.tabs.latencia.little_cards.ip_externo')"
              :value="latestIP.out"
              icon="network-wired"/>
        </div>
        <div class="col-lg-4 col-md-12 p-2">
        <LittleCard
            variant="warning"
            :text="$t('monitoramento.resumo.tabs.latencia.little_cards.ultima_atualizacao')"
            :value="latestIP.created_at | formatDate"
            icon="network-wired"/>
      </div>
      </div>
    </b-overlay>
    <b-overlay :show="loadingStatus">
      <div class="row m-0">
        <div class="col-lg-4 col-md-12 p-2">
          <LittleCard
              variant="primary"
              :text="$t('monitoramento.resumo.tabs.latencia.little_cards.latencia')"
              :value="average(status, 'latency')"
              valueDescription="ms"
              icon="clock"/>
        </div>
        <div class="col-lg-4 col-md-12 p-2">
          <LittleCard
              variant="success"
              :text="$t('monitoramento.resumo.tabs.latencia.little_cards.disco')"
              :value="freeDisc"
              valueDescription="GB"
              icon="hdd"/>
        </div>
        <div class="col-lg-4 col-md-12 p-2">
          <LittleCard
              variant="danger"
              :text="$t('monitoramento.resumo.tabs.latencia.little_cards.cpu')"
              :value="latestStatus.temperature_cpu"
              valueDescription="° C"
              icon="thermometer-half"/>
        </div>
      </div>
      <div style="width: 90%;">
        <line-chart :data="latency"/>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import LittleCard from "@/components/LittleCard";

export default {
  name: "Latency",
  components: {LittleCard},
  computed: {
    ...mapGetters({
      ip: 'vns/monitor/getIp',
      vns: 'vns/current',
      status: 'vns/monitor/getStatus',
      latestStatus: 'vns/monitor/latestStatus'
    }),
    latestIP() {
      if (this.ip.length > 0){
        return this.ip[this.ip.length - 1]
      }
      return {
        in: null,
        out: null,
        created_at: null
      }
    },
    freeDisc() {
      if (this.latestStatus && this.latestStatus.total_disk && this.latestStatus.used_disk) {
        return Math.round((this.latestStatus.total_disk - this.latestStatus.used_disk) * 100) / 100
      }
      return null
    },
    latency() {
      if (this.status instanceof Array) {
        const data = {}
        this.status.map(s => {
          data[s.created_at + ' -03:00'] = s.latency
        })
        return [{
          name: this.$t('monitoramento.resumo.tabs.latencia.title'),
          data
        }]
      }
      return []
    }
  },
  data() {
    return {
      loadingIP: false,
      loadingStatus: false
    }
  },
  methods: {
    ...mapActions([
      'vns/monitor/listIp',
      'vns/monitor/listStatus',
      'vns/monitor/listLastStatus',
      'vns/monitor/listLastIp'
    ]),
    average(arrayObj, key) {
      if (arrayObj.length > 0) {
        const avg = arrayObj.reduce((a, b) => {
          if (Object.keys(a).length > 0) return a[key] + b[key]
          return a + b[key]
        }, 0) / arrayObj.length;
        return Math.round(avg * 100) / 100
      }
      return null
    },
    async loadIpData() {
      this.loadingIP = true
      await this['vns/monitor/listIp']({
        filters: [
          ['vns_id', '=', this.vns.id],
          ['minutes', '>=', 10],
        ]
      })
      if (this.ip.length === 0){
        await this['vns/monitor/listLastIp'](this.vns.id)
      }
      this.loadingIP = false
    },
    async loadStatusData() {
      this.loadingStatus = true
      await this['vns/monitor/listStatus']({
        id: this.vns.id,
        vnsId: this.vns.id,
        minutes: 10
      })
      if (this.status.length === 0){
        await this['vns/monitor/listLastStatus'](this.vns.id)
      }
      this.loadingStatus = false
    }
  },
  mounted() {
    if (this.ip.length === 0) {
      this.loadIpData()
    }
    if (this.status.length === 0) {
      this.loadStatusData()
    }
  }
}
</script>